import React from 'react'
import { Redirect } from 'react-router-dom'

const MyAccountRedirection: React.FC = () => <Redirect to="/account/my-account/personal-information" />

export default MyAccountRedirection